import { combineReducers } from "redux";
import scores2020Reducer from "./2020-scores-fetch";

const reducers = combineReducers({ scores2020Reducer });

export default reducers;
